import script from "./FormSubmission.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormSubmission.vue?vue&type=script&lang=ts&setup=true"

import "./FormSubmission.vue?vue&type=style&index=0&id=5c2242d6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2242d6"]])

export default __exports__